import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LoadingPage from "../../common/components/common/LoadingPage";
import { WHITE } from "../../theme/colors";
import { getListDashboard } from "../UAA/service/menuConfigService";
import ButtonRedirect from "./component/ButtonRedirect";

const HomePage = () => {
  const { currentBizzApp } = useSelector((state) => state.bizzApps);
  const [loading, setLoading] = useState(false);
  const [detailDashboard, setDetailDashboard] = useState();
  const getListDashboardConfig = async (productId) => {
    try {
      setLoading(true);
      const res = await getListDashboard({ page: 0, size: 100, productId });
      setDetailDashboard(res?.data?.data?.content[0]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      // errorMsg(error);
    }
  };

  useEffect(() => {
    if (currentBizzApp?.id) {
      getListDashboardConfig(currentBizzApp?.id);
    }
  }, [currentBizzApp]);

  return (
    <Box
      className="m-15 p-25 h-full text-center"
      style={{ backgroundColor: WHITE }}
    >
      {loading ? (
        <LoadingPage />
      ) : detailDashboard ? (
        <>
          <Typography
            variant="h6"
            dangerouslySetInnerHTML={{ __html: detailDashboard.description }}
          />
          <Box className="grid grid-cols-3 gap-30 mt-25">
            {detailDashboard?.menus?.map((v, index) => {
              return <ButtonRedirect data={v} key={index} />;
            })}
          </Box>
        </>
      ) : (
        <>
          {currentBizzApp && (
            <>
              <Typography variant="h6">
                {`Welcome to ${currentBizzApp?.name} service`}
              </Typography>
            </>
          )}
        </>
      )}
    </Box>
  );
};

export default HomePage;
